<template>
  <BuilderWrapper
    title="Info Panel"
    helpful-tip="The Info Panel is an optional feature to provide an easy place to answer common user questions or display additional information. A third menu button is added which, when clicked, displays a modal with a custom text field."
    :show-premium-feature="!featureEnabled"
    :expand-disabled="!featureEnabled"
  >
    <LabelledInput>
      <b-checkbox
        v-if="featureEnabled"
        v-model="enabled"
      >
        Show Info Panel
      </b-checkbox>
    </LabelledInput>

    <template v-if="featureEnabled && enabled && !exclude.includes('settings')">
      <LabelledInput
        label="Modal Title"
      >
        <b-input
          v-model="title"
          type="text"
        />
      </LabelledInput>

      <TTNoField :config-path="[FAQ_CONFIG_KEY,'text']" />
    </template>
  </BuilderWrapper>
</template>

<script lang="ts">

import { PropType } from 'vue'
import Component from 'vue-class-component'

import BuilderWrapper from '@/components/builder/UI/BuilderWrapper.vue'
import LabelledInput from '@/components/builder/UI/LabelledInput.vue'
import TTNoField from '@/components/TipTap/wrappers/TTNoField.vue'
import FeatureSetMixin from '@/mixins/FeatureSetMixin'
import { FeatureKeys, StoryKeys } from '@/types'
import { FAQ_CONFIG_KEY } from '@/constants'

const components = {
  BuilderWrapper,
  LabelledInput,
  TTNoField,
}

const props = {
  exclude: {
    type: Array as PropType<string[]>,
    default: () => [],
  },
}

@Component({
  components,
  watch: {
    enabled () {
      if (!(StoryKeys.INFO_FAQ in this.$typedStore.primary.app.config.storySettings)) {
        // Add default storySettings
        this.$typedStore.primary.app.updateConfig({
          configPath: ['storySettings', StoryKeys.INFO_FAQ],
          value: {
            fontSize: 100,
            fontColor: '#000000',
            fontFamily: 'Arial',
            headingColor: '',
            linkColor: '',
          },
        })
      }
    },
  },
})
export default class FaqSettings extends FeatureSetMixin.extend({ props }) {
  FAQ_CONFIG_KEY = FAQ_CONFIG_KEY

  featureKey = FeatureKeys.INFO_PANEL
  featureEnabled!: boolean

  get enabled () {
    return this.$typedStore.primary.app.config[FAQ_CONFIG_KEY].enabled
  }

  set enabled (value) {
    this.$typedStore.primary.app.updateConfig({
      configPath: [FAQ_CONFIG_KEY, 'enabled'],
      value,
    })
  }

  get title () {
    return this.$typedStore.primary.app.config[FAQ_CONFIG_KEY].title
  }

  set title (value) {
    this.$typedStore.primary.app.updateConfig({
      configPath: [FAQ_CONFIG_KEY, 'title'],
      value,
    })
  }
}

</script>
